import { cn } from "@/lib/utils";
import { IconChevronRight } from "@tabler/icons-react";
import Link from "next/link";

interface ActivateModeButtonProps {
  mode: "red" | "blue";
  label?: string;
  icon?: React.ReactNode;
  className?: string;
}

export const ModeButton = ({
  mode,
  label,
  icon = <IconChevronRight stroke={2} />,
  className,
}: ActivateModeButtonProps) => {
  return (
    <Link
      href={mode === "red" ? "/launchpad/degen" : "/launchpad/builder"}
      className={cn(
        "rounded-full px-6 py-2 lg:py-4 lg:px-16 text-xs lg:text-base border flex items-center gap-2 text-nowrap text-white w-fit hover:scale-[99%] hover:opacity-90 transition-all duration-300",
        className,
        {
          "border-[#B12120]": mode === "red",
          "border-[#1652B2]": mode === "blue",
        }
      )}
      style={{
        background:
          mode === "blue"
            ? "radial-gradient(45.96% 48.98% at 49.8% 0%, #6FA6FF 0%, #1F75FE 100%)"
            : "radial-gradient(45.96% 48.98% at 49.8% 0%, #FF6160 0%, #DD2928 100%)",
      }}
    >
      {label} {icon}
    </Link>
  );
};
